import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import QueryForm from '../../../Pages/Static/queryForm';
import AlorBanner from '../../../../Assets/images/DovesByDoranPalomo.png';
import AlorBannerMobile from '../../../../Assets/images/DovesByDoranPalomo.png';
import { isMobileOnly } from 'react-device-detect';

const Doves = () => {
  return (
    <>
      <div className="watch_repaire_services_page">
        <Container fluid>
          <Row>
            <Col sm={12} md={12} lg={12} className="p-0">
              <div>{isMobileOnly ? <Image src={AlorBannerMobile} className="img-fluid"  alt='Oris' /> : <Image src={AlorBanner} className="img-fluid"  alt='Oris' />}</div>
            </Col>
          </Row>

          <div className="text-center pt-5">
            <Row className="justify-content-center">
              <Col lg={8}>
                <h3 className="text-center text-uppercase">Doves By Doran Palomo</h3>
                <p>Elevate your style with Doves By Doran Palomo Jewelry, a fusion of timeless elegance and contemporary allure. Each piece is a work of art, meticulously crafted to capture the essence of luxury and sophistication. Embrace the beauty of self-expression with Doves, where every creation tells a story of exquisite craftsmanship and refined taste.</p>
              </Col>
            </Row>
          </div>
        </Container>
        <QueryForm />
      </div>
    </>
  );
};

export default Doves;
